/**
 * Check if an element is in the viewport
 *
 * Usage: if ($(this).isInViewport()) { ...your code }
 */

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height() / 2;

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

/**
 * Check if an element fits in the viewport (width)
 *
 * Usage: if ($(this).widthFitsInViewport()) { ...your code }
 */

$.fn.isWiderThanViewport = function() {
    if (typeof(this[0]) != 'undefined' && this[0] != null) {
        
        const elementWidth = this[0].scrollWidth;
        const viewportWidth = $(window).width();

        return elementWidth > viewportWidth;
    }
}
